import EventShowcaseBody from '../EventShowcaseBody';

interface Props {
  displayType: string;
  code: string;
}

const ShowcaseSingleContent = ({ displayType, code }: Props) => {
  return (
    <div className="relative">
      <EventShowcaseBody displayType={displayType} showcaseCode={code} />
    </div>
  );
};

export default ShowcaseSingleContent;
